import React, {Component} from 'react';
import DeleteEvent from '../components/DeleteEvent';
import ImportCsv from '../components/ImportCsv';
// import ShowInscription from '../components/ShowInscription';
import ShowRaces from '../components/ShowRaces';
import Message from '../components/Message';
import Header from '../components/Header';
import cookie from 'react-cookies';

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      tokenId: '',
      interpretedAlert: null,
      showDeclarative: false
    };
  }

  componentDidMount() {
    let cookies = cookie.loadAll();

    fetch("https://api.goaltiming.be/events?type=all")
      .then(res => res.json())
      .then(
        (result) => {
            const sortedEvents = result.sort((a, b) => a.date - b.date);
            const selectedEvents = [];

            for (var i = 0; i<(result.length); i++) {
              var eventDate = this.convertDate(sortedEvents[i].date);
              var publicDate = this.convertDate(sortedEvents[i].publicationDate);
              
              selectedEvents.push({
                name : sortedEvents[i].name,
                date : eventDate,
                publicationDate : publicDate,
                banner : sortedEvents[i].banner,
                id : sortedEvents[i].EventId
              });
            }

          this.setState({
            isLoaded: true,
            items: selectedEvents
          });

        },(error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )

      if(!cookies.tokenId){
          let d = new Date();
          var url = window.location.href;
          var url = window.location.hash;
          var selected = url.split('id_token' + '=');


          if(selected[1] !== undefined){
              var value = selected[1].split('&');
              let tid = value[0];
              
              d.setTime(d.getTime() + (55*60*1000));
              cookie.save("tokenId", tid, {path: "/", expires: d});

              const [header, payload, signature] = tid.split('.');
              const decodedPayload = JSON.parse(atob(payload));
              if(decodedPayload.email == 'revendeur.goaltiming@gmail.com'){
                window.location.replace("/resellers/view");
              }

              this.setState({tokenId: tid});
          }else{
            var url = window.location.pathname;
            if(url.substr(1) != 'view'){
              d.setTime(d.getTime() + (55*60*1000));
              cookie.save("selectedRun", url.substr(1), {path: "/"});
            }
            window.location.replace("https://auth.goaltiming.be/login?client_id=1n014khs8r0ghlvuvg7vds0tbg&response_type=token&scope=email%20openid&redirect_uri=https%3A%2F%2Fadmin.goaltiming.be%2Fview&fbclid=IwAR02CuBWOwLypoSCXUZ_MPuHVGTK7KUyg2cmEOA1JDsrUZgM8KnM36PV6gA");
          }
      }else{
          this.setState({tokenId: cookies.tokenId});
          const [header, payload, signature] = cookies.tokenId.split('.');
          const decodedPayload = JSON.parse(atob(payload));
          if(decodedPayload.email == 'revendeur.goaltiming@gmail.com'){
            window.location.replace("/resellers/view");
          }
      }
  }

  convertDate(d){
    var date = new Date(d*1000);
    var day = date.getDate();
    var month = date.getMonth()+1;
    var year = date.getFullYear();

    return day + '/' + month + '/' + year;
  }

  render() {
    const { error, isLoaded, items, tokenId } = this.state;
    const action = this.props.match.params.action;

    if (error) {
      return <div>Erreur : {error.message}</div>;
    } else if (!isLoaded || tokenId === '') {
      return <div className="loader">Loading...</div>;
    } else {
      return (

        <div>
            {/* [ Header ] start */}
              <Header />
            {/* [ Header ] end */}

            {/* [ Main Content ] start */}
            <section className="pcoded-main-container">
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            {/* [ breadcrumb ] start */}
                            <div className="page-header">
                                <div className="page-block">
                                    <div className="row align-items-center">
                                        <div className="col-md-12">
                                            <div className="page-header-title">
                                                <h5 className="m-b-10">Goal Timing - Les évènements</h5>
                                            </div>
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item"><a href="/"><i className="feather icon-home"></i></a></li>
                                                <li className="breadcrumb-item"><a href="/events/">Events</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* [ breadcrumb ] end */}
                            <div className="main-body">     
                                <div className="page-wrapper">
                                    {/* [ Main Content ] start */}
                                    <div className="row">
                                        {/* [ stiped-table ] start */}
                                        <div className="col-xl-12">
                                            <div className="card">
                                              
                                                <Message datamesage={action} />

                                                <div className="card-header">
                                                    <h5>Gestion des évènements</h5>
                                                    <span className="d-block m-t-5"><a href="/events/create">+ ajouter un évènement  </a></span>
                                                </div>
                                                <div className="card-block table-border-style">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Titre</th>
                                                                    <th>Date de l'évènement</th>
                                                                    <th>Date de publication</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {items.map(function(item, i){
                                                                   return <tr key={i}>
                                                                            <th scope="row">{i+1}</th>
                                                                            <td>{item.name}</td>
                                                                            <td>{item.date}</td>
                                                                            <td>{item.publicationDate}</td>
                                                                            <td>
                                                                              <a href={'/events/edit/' + item.id}>Editer</a> |
                                                                              &nbsp;<ImportCsv dataid={item.id} token={tokenId} />
                                                                              &nbsp;<ShowRaces dataid={item.id} token={tokenId} />

                                                                              <DeleteEvent dataid={item.id} token={tokenId} />
                                                                            </td>
                                                                          </tr>;
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* [ stiped-table ] end */}
                                    </div>
                                    {/* [ Main Content ] end */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        
      );
    }
  }
}

export default Events